import React from 'react';
import Lottie from 'lottie-react';
import { SpinLoading } from 'antd-mobile';
import loadingAnimation from '@/assets/json/list_load.json';

const wrapStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  width: '100vw',
};

const FallbackSpinner = () => (
  <div style={wrapStyle}>
    <SpinLoading style={{ '--size': '24px' }} color="primary" />
  </div>
);

class LottieGuard extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error('PageLoading lottie failed', error);
  }

  render() {
    if (this.state.hasError) return this.props.fallback;
    return this.props.children;
  }
}

const PageLoading = () => (
  <LottieGuard fallback={<FallbackSpinner />}>
    <div style={wrapStyle}>
      <Lottie
        animationData={loadingAnimation}
        loop
        autoplay
        style={{ width: 24, height: 24 }}
      />
    </div>
  </LottieGuard>
);

export default PageLoading;
